import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=4595eecb&scoped=true"
import script from "./TagSelect.vue?vue&type=script&lang=ts"
export * from "./TagSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4595eecb",
  null
  
)

export default component.exports